import BBAnalytics from './BBAnalytics';
import BitsyApollo from './BitsyApollo';
import SubscriptionDateService from './SubscriptionDateService';
import Logger from './Logger';

const determineAddOnTotals = (subscription) => {
  let subtotal = 0.0;
  let total = 0.0;
  subscription.addOnsWithDetails.forEach((addOn) => {
    if (!addOn.replacementItem) {
      subtotal += addOn.product.originalCost;
      total += addOn.product.actualCost;
    }
  });

  subscription.recurringAddOns.forEach((recurringAddOn) => {
    const actualCost = recurringAddOn.amountToCharge;

    subtotal += actualCost;
    total += actualCost;
  });
  const discountTotal = subtotal - total;
  return {
    subtotal,
    discountTotal,
    total,
  };
};

const hasShopAddOnProduct = (subscription) => {
  if (subscription.recurringAddOns && subscription.recurringAddOns.length) {
    return true;
  }
  // look for Box Add-On tag
  const doTagsHaveBoxAddOn = subscription.addOnsWithDetails.map((addOn) => {
    if (!addOn.product.tags) return null;
    return addOn.product.tags.some((tag) => tag.description === 'Box Add-On');
  });
  // if there is an add on without Box Add On tag, it must be a shop add on
  return doTagsHaveBoxAddOn.includes(false);
};

const handleAddOrRemoveAddOn = async (product, state, isRecurringAddOn) => {
  const newState = { ...state };
  const { subscription } = state;
  newState.productError = null;
  newState.modalType = null;
  newState.showProductDetails = false;
  newState.productToShow = null;
  BBAnalytics.viewedProductEvent(product);
  let productId = product._id;
  let productAlreadyAdded = subscription.addOnsWithDetails.some(
    (addOn) => addOn.product._id === product._id,
  );

  if (isRecurringAddOn) {
    subscription.recurringAddOns.forEach((addOn) => {
      if (addOn.product._id === product._id) {
        productAlreadyAdded = true;
      } else if (
        addOn.product.name === 'Premium Upgrade' &&
        product.name === 'Premium Upgrade'
      ) {
        productAlreadyAdded = true;
        // Sets data productId to target old premium upgrade product for removal
        productId = addOn.product._id;
      }
    });
  }

  let gaAction;
  if (isRecurringAddOn) {
    gaAction = productAlreadyAdded
      ? 'Subscription Recurring Add-on Removed'
      : 'Subscription Recurring Add-on Added';
  } else {
    gaAction = productAlreadyAdded
      ? 'Subscription Add-on Removed'
      : 'Subscription Add-on Added';
  }

  const gaLabel = product.name;
  BBAnalytics.subscriptionAddOnsChanged(gaAction, gaLabel);

  const res = await BitsyApollo.addOrRemoveProductToAddOns({
    subscriptionId: subscription._id,
    productId,
    productAlreadyAdded,
    isRecurringAddOn,
  });
  if (res) {
    if (res.error) {
      Logger.error(res.error);
      newState.modalType = 'PRODUCT ERROR';
    } else {
      if (!productAlreadyAdded) {
        if (!isRecurringAddOn) {
          newState.modalType = 'THANK YOU';
        } else {
          newState.modalType = 'THANK YOU RECURRING';
        }
      }
      newState.subscription = res;
      newState.totals = determineAddOnTotals(res);
    }
  }
  return newState;
};

const getEligibleSubscriptions = (subscriptions) => {
  const now = new Date();
  let soonestEligibility = new Date(now.getFullYear() + 10, 1, 1);
  const checkedSubscriptions = subscriptions.map((sub) => {
    if (!sub.canMakePayment) return null;
    if (sub.status === 'ACTIVE' && !sub.isSkipCurrentMonth) {
      const nextRenewalDate = SubscriptionDateService.getNextRenewalDate(
        sub,
        now,
      );

      const customizeEligibilityDate = SubscriptionDateService.getCustomizeEligibilityDate(
        sub,
        now,
      );
      const allowCustomize = SubscriptionDateService.isEligibleForCustomize(
        nextRenewalDate,
        customizeEligibilityDate,
        now,
      );
      const subHasShopAddOnProduct = hasShopAddOnProduct(sub);
      if (allowCustomize || subHasShopAddOnProduct) {
        return sub;
      }
      if (customizeEligibilityDate < soonestEligibility) {
        soonestEligibility = customizeEligibilityDate;
      }
      return 'Not Ready';
    }
    return null;
  });

  if (checkedSubscriptions.every((elem) => elem === null)) {
    return null;
  }

  const eligibleSubscriptions = checkedSubscriptions.filter(
    (elem) => elem !== null && elem !== 'Not Ready',
  );

  return eligibleSubscriptions;
};

export default {
  handleAddOrRemoveAddOn,
  determineAddOnTotals,
  hasShopAddOnProduct,
  getEligibleSubscriptions,
};
